import Box from '@sendsprint/ui-react/dist/components/Box';
import Text from '@sendsprint/ui-react/dist/components/Text';
import React from 'react';
import CloseBtn from '../closeBtn';

interface Props {
  label: string;
  handleClose: () => void;
}

const Dialog2Header = ({ handleClose, label }: Props) => {
  return (
    <Box className="ss-flex ss-justify-between ss-mb-6 ss-gap-4 ss-items-center">
      <Text className="ss-text-neutral-500" variant="h5">
        {label}
      </Text>
      <CloseBtn onClick={handleClose} />
    </Box>
  );
};

export default Dialog2Header;
